var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#DCDCDC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.8444 56.0629H41.4561C40.6523 56.0629 40 55.4116 40 54.6028V25.3978C40 24.5918 40.6523 23.9375 41.4561 23.9375H61.8444C62.6485 23.9375 63.3009 24.5917 63.3009 25.3978V54.6028C63.301 55.4116 62.6486 56.0629 61.8444 56.0629Z",
    fill: "#F1F5F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0192 32.6994H41.4561C40.6523 32.6994 40 32.0479 40 31.2391C40 30.4297 40.6523 29.7788 41.4561 29.7788H56.0192C56.8229 29.7788 57.4753 30.4329 57.4753 31.2391C57.4753 32.0452 56.8229 32.6994 56.0192 32.6994Z",
    fill: "#1B80E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0192 38.5403H41.4561C40.6523 38.5403 40 37.8882 40 37.0794C40 36.2706 40.6523 35.6191 41.4561 35.6191H56.0192C56.8229 35.6191 57.4753 36.2738 57.4753 37.0794C57.4753 37.8861 56.8229 38.5403 56.0192 38.5403Z",
    fill: "#1B80E4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0192 44.3811H41.4561C40.6523 44.3811 40 43.73 40 42.9208C40 42.1118 40.6523 41.4604 41.4561 41.4604H56.0192C56.8229 41.4604 57.4753 42.1145 57.4753 42.9208C57.4753 43.7268 56.8229 44.3811 56.0192 44.3811Z",
    fill: "#1B80E4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.0192 50.2218H41.4561C40.6523 50.2218 40 49.5709 40 48.7617C40 47.9527 40.6523 47.3018 41.4561 47.3018H56.0192C56.8229 47.3018 57.4753 47.956 57.4753 48.7617C57.4753 49.5677 56.8229 50.2218 56.0192 50.2218Z",
    fill: "#1B80E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3854 18.4354C42.0529 18.1552 41.6073 18.0386 41.1881 18.1233L17.8871 22.504C17.1995 22.6323 16.6987 23.2368 16.6987 23.9377V56.063C16.6987 56.7639 17.1969 57.3687 17.8871 57.497L41.1881 61.8781C41.2785 61.8955 41.3656 61.9041 41.4561 61.9041C41.7938 61.9041 42.1229 61.787 42.3854 61.5683C42.7205 61.2907 42.912 60.8788 42.912 60.4441V19.5571C42.9119 19.1215 42.7204 18.7127 42.3854 18.4354Z",
    fill: "#1872D9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6225 47.4651C35.5466 48.1335 35.0223 48.6683 34.3554 48.7501C34.294 48.7588 34.2358 48.7616 34.1749 48.7616C33.5748 48.7616 33.0269 48.388 32.8117 47.8154L29.8055 39.7783L26.7998 47.8154C26.5669 48.4406 25.9549 48.8228 25.2798 48.7531C24.6183 48.6828 24.0882 48.1688 23.9952 47.5057L22.5387 37.2841C22.4251 36.4894 22.9786 35.7483 23.7737 35.6338C24.5715 35.5177 25.3086 36.0752 25.4221 36.8725L26.0717 41.4402L28.4401 35.1056C28.865 33.9664 30.7409 33.9664 31.1689 35.1056L33.3993 41.0688L34.183 33.9954C34.2733 33.1952 35.0135 32.6203 35.7913 32.7051C36.5918 32.7978 37.1659 33.5194 37.0788 34.32L35.6225 47.4651Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordIcon);
export default __webpack_public_path__ + "static/media/word-icon.ba09dc0c74512b3819aa2ec0b16bb897.svg";
export { ForwardRef as ReactComponent };